export default "__VITE_ASSET__DNf3TClA__"